import type { ReactNode } from 'react';
import { cn } from '../lib/utils';
import { Button } from './button';

/** DESIGN.md §6 States — Loading. */
export function LoadingRow({ label, className }: { label: string; className?: string }) {
  return (
    <p
      role="status"
      aria-live="polite"
      className={cn('py-12 text-center text-sm text-[var(--ink-faint)]', className)}
    >
      {label}
    </p>
  );
}

/** DESIGN.md §6 States — Error, with the request id and an optional retry. */
export function ErrorRow({
  message,
  requestId,
  retryLabel,
  onRetry,
  retrying,
  className,
}: {
  message: ReactNode;
  requestId?: ReactNode;
  retryLabel?: string;
  onRetry?: () => void;
  retrying?: boolean;
  className?: string;
}) {
  return (
    <div role="alert" className={cn('py-12 text-center text-sm text-[var(--negative)]', className)}>
      <p>{message}</p>
      {requestId ? <p className="mt-1 font-mono text-xs">{requestId}</p> : null}
      {onRetry && retryLabel ? (
        <Button className="mt-4" onClick={onRetry} disabled={retrying}>
          {retryLabel}
        </Button>
      ) : null}
    </div>
  );
}

/** DESIGN.md §6 States — Empty: says what will make data appear. */
export function EmptyText({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <p className={cn('py-12 text-center text-sm text-[var(--ink-soft)]', className)}>{children}</p>
  );
}
